'use strict';

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
var _this = this;
var consent = {
  getString: function getString(urlAccept, textAccept) {
    //immediately return a calculate string value
    return "<div class=\"consent-drawer\" id=\"consent-tracking\" role=\"dialog\">\n        <div class=\"consent-text-wrapper\"></div>\n        <div class=\"consent-button-wrapper\">\n        <button class=\"affirm btn btn-primary\" data-url=\"".concat(urlAccept, "\" autofocus>\n        ").concat(textAccept, "\n        </button>\n        </div>\n        </div>");
  },
  showConsentDrawer: function showConsentDrawer($trackingElement) {
    if ([undefined, null].indexOf($trackingElement) !== -1 || !$trackingElement.data('caonline')) {
      return;
    }
    var namespace = '.consenttrackingdrawer ',
      urlContent = $trackingElement.data('url'),
      urlAccept = $trackingElement.data('accept'),
      textAccept = $trackingElement.data('accepttext');
    var htmlString = consent.getString(urlAccept, textAccept);
    $('body').append(htmlString);
    var $consentTracking = $('#consent-tracking');
    $.ajax({
      url: urlContent,
      type: 'get',
      dataType: 'html',
      context: $consentTracking,
      success: function success(response) {
        this.find('.consent-text-wrapper').html(response);
      },
      error: function error() {
        this.remove();
      }
    });
    $consentTracking.find('.consent-button-wrapper button').on('click' + namespace, function (event) {
      event.preventDefault();
      var url = $(event.target).data('url');
      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        context: $consentTracking,
        complete: function complete() {
          this.remove();
        },
        error: function error() {
          this.remove();
        }
      });
    });
  },
  init: function init() {
    var namespace = '.consenttracking ',
      $body = $('body'),
      $trackingConsent = $('.tracking-consent');
    if ($('.consented').length === 0 && $trackingConsent.hasClass('api-true')) {
      consent.showConsentDrawer($trackingConsent);
    }
    $trackingConsent.each(function (index, element) {
      var $this = $(_this);
      if ($this.hasClass('api-true')) {
        $this.on('click' + namespace, function () {
          consent.showConsentDrawer($this);
        });
      }
    });
  }
};
module.exports = consent;